// extracted by mini-css-extract-plugin
export default {"root":"delay-field_root__F4g5G","label":"delay-field_label__KkRCi","input":"delay-field_input__-OGnj","inputArrows":"delay-field_inputArrows__IPKXY"};